import React from "react"

import Layout from "../../layout/Layout"

import { Container, Row, Col } from "react-bootstrap"
import TitleBoldLarge from "../../components/typography/TitleBoldLarge"
import TitleLight from "../../components/typography/TitleLight"
import HelmetInject from "../../components/HelmetInject"

import ImageComplete from "../../layout/parts/ImageComplete.js"
import vaccineLogo from "../../images/vaccine.svg"

import { Link } from "gatsby"

export default function CovidVaccineMap() {
  return (
    <>
      <HelmetInject
        title="Our Covid Vaccine Map"
        contentDescription="" //Like Neil Patel Sytle
      />
      <Layout>
        <Container fluid className="background-color-white mb-5">
          {/* TITLE H1  */}
          <Row>
            <Col className="text-center">
              <h1 className="mt-5">
                <TitleBoldLarge>Our Covid Vaccine Map</TitleBoldLarge>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <h2 className="mt-5">
                <Link to="/covid-vaccine-map">
                  <TitleLight>Use our Covid Vaccine Map</TitleLight>
                </Link>
              </h2>
            </Col>
          </Row>
        </Container>
        <Container className="background-color-white">
          <Row>
            <Col className="text-center mt-3">
              <ImageComplete
                alt={"Covid Vaccine Map"}
                src={vaccineLogo}
                className="img-fluid"
                width="400"
                height="400"
              />
            </Col>
          </Row>
          {/* TITLE H2 SIMPLE */}
          <Row>
            <Col className="text-center mt-3">
              <h2 className="mt-5">
                <strong>
                  <TitleLight>Our improved covid vaccine map</TitleLight>
                </strong>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              Our covid vaccine map includes all info needed for see the
              evolution of the vaccines in one map.
            </Col>
          </Row>
          {/* TITLE H2 SIMPLE */}
          <Row>
            <Col className="text-center mt-3">
              <h2 className="mt-5">
                <strong>
                  <TitleLight>
                    Live information in Our covid vaccine map
                  </TitleLight>
                </strong>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              Whe want the live info because the information is changing faster.
              In our Covid vaccine map you can see that info crearly explained.
            </Col>{" "}
          </Row>
          {/* TITLE H2 SIMPLE */}
          <Row>
            <Col className="text-center mt-3">
              <h2 className="mt-5">
                <strong>
                  <TitleLight>Data of Phases and Covid vaccine map</TitleLight>
                </strong>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              With our covid vaccine map you can get also the information of the
              different phases of Covid vaccines classified in the different
              phases of testing and developing.
            </Col>{" "}
          </Row>
          {/* TITLE H2 SIMPLE */}
          <Row>
            <Col className="text-center mt-3">
              <h2 className="mt-5">
                <strong>
                  <TitleLight>
                    Live info of countries in the Covid vaccine world map
                  </TitleLight>
                </strong>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              This Covid vaccine map, shows the different companies around the
              world situated in the world map
            </Col>{" "}
          </Row>
        </Container>
      </Layout>
    </>
  )
}
